import React from 'react'

import { Box, Text } from '../../Shared/Base'
import { useAppStoreLink, useFetchApi, useGooglePlayLink } from '../../Shared/hooks'
import ModalContact from './ModalContact'
import ModalScam from './ModalScam'
import { useLocation } from 'react-router'
import { absolute_url, qps_from_search } from '../../../helpers/misc'
import ModalSimple from '../../Shared/ModalSimple'
import QRCode from 'qrcode'

const IconAdContact = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20">
      <g clipPath="url(#clip0)">
        <path
          fill="#fff"
          d="M11.667 12.167a1.917 1.917 0 01-1.167.333 1.917 1.917 0 01-1.167-.333L.5 7.417v8.417a2.5 2.5 0 002.5 2.5h15a2.5 2.5 0 002.5-2.5V7.417l-8.833 4.75z"
        />
        <path
          fill="#fff"
          d="M18 1.667H3a2.5 2.5 0 00-2.5 2.5V5a.875.875 0 00.417.75l9.166 5a.75.75 0 00.417.084.75.75 0 00.417-.084l9.166-5A.875.875 0 0020.5 5v-.833a2.5 2.5 0 00-2.5-2.5z"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h20v20H0z" transform="translate(.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

// AdBottomTel
const IconAdTel = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g clipPath="url(#clip0)">
        <path
          fill="#fff"
          d="M12.09 12.905l-1.946 1.917a15.78 15.78 0 01-2.81-2.156 15.958 15.958 0 01-2.157-2.808l1.916-1.945a.833.833 0 00.174-.914l-2-4.658a.833.833 0 00-.975-.477l-3.667.969A.833.833 0 000 3.666a17.617 17.617 0 004.988 11.347A17.614 17.614 0 0016.338 20a.834.834 0 00.834-.625l.968-3.666a.834.834 0 00-.477-.98l-4.658-2a.833.833 0 00-.916.176zM20 8.333h-1.667a6.674 6.674 0 00-6.666-6.666V0A8.343 8.343 0 0120 8.333z"
        />
        <path
          fill="#fff"
          d="M16.667 8.333H15A3.333 3.333 0 0011.667 5V3.333a5.005 5.005 0 015 5z"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const useLA_ad_callbacks = ad_id => {
  const fetcher = useFetchApi()
  const [contact_info, set_contact_info] = React.useState(null)

  const get_contact_info = React.useCallback(async () => {
    const res = await fetcher(`ad/${ad_id}/contact_info`)

    return res
  }, [ad_id, fetcher])

  const log_stat = React.useCallback(
    async event_name => {
      await fetcher(`ad/${ad_id}/log`, { method: 'POST', body: JSON.stringify({ event_name }) })
    },
    [ad_id, fetcher]
  )

  const load_contact_info = React.useCallback(async () => {
    if (ad_id) {
      const res = await get_contact_info()
      set_contact_info(res)
    }
  }, [ad_id, get_contact_info])

  const redirect = React.useCallback(async () => {
    if (contact_info && contact_info.redirect_url) {
      await log_stat('REDIRECT')
      document.location.href = contact_info.redirect_url
    }
  }, [contact_info, log_stat])

  return { contact_info, log_stat, load_contact_info, redirect }
}

const useModalScam = ({ redirect, owner_type, search_type }) => {
  const [modal_scam_visible, set_modal_scam_visible] = React.useState(false)
  const modale_previously_hidden =
    window.localStorage &&
    window.localStorage.getItem &&
    window.localStorage.getItem('LA_hide_result_modal_spam')

  const set_modale_scam_viewed = React.useCallback(() => {
    window.localStorage &&
      window.localStorage.setItem &&
      window.localStorage.setItem('LA_hide_result_modal_spam', '1')
  }, [])

  const onRedirect = React.useCallback(() => {
    if (!modale_previously_hidden && owner_type === 'Particulier' && search_type === 'for_rent') {
      set_modal_scam_visible(true)
    } else {
      redirect()
    }
  }, [modale_previously_hidden, owner_type, search_type, redirect])

  const onModalScamClose = React.useCallback(() => {
    set_modal_scam_visible(false)
    set_modale_scam_viewed()
    redirect()
  }, [redirect, set_modale_scam_viewed])

  return { modal_scam_visible, onModalScamClose, onRedirect }
}

const QRCodeMessageButtonDesktop = ({ link }) => {
  const google_play_link = useGooglePlayLink()
  const apple_store_link = useAppStoreLink()
  const [qrcode, set_qrcode] = React.useState(null)
  const [modal_open_jinka, set_modal_open_jinka] = React.useState(false)
  React.useEffect(() => {
    QRCode.toDataURL(link, { width: 200, margin: 0 }).then(url => {
      set_qrcode(url)
    })
  }, [link])

  return (
    <>
      {modal_open_jinka ? (
        <ModalSimple onClose={() => set_modal_open_jinka(false)}>
          <Box textAlign="center" mt={20}>
            <Box as="img" src={qrcode} alt="Illustration fusée" width="200" />
          </Box>
          <Text className="fz-24" textAlign="center" color="n_primary" mt={20}>
            <strong>
              <Box as="span" color="n_secondary">
                Installez l'application JINKA
              </Box>{' '}
              puis scannez ce QRCode avec votre appareil photo.
            </strong>
          </Text>

          <Box
            display="grid"
            gridTemplateColumns={{ sm: 'repeat(2, max-content)', xs: '1fr' }}
            gridGap={30}
            justifyContent="center"
            my={40}
          >
            <Box
              as="a"
              href={apple_store_link}
              target="_blank"
              rel="noopener noreferrer"
              textAlign="center"
            >
              <Box
                as="img"
                src="https://res.cloudinary.com/loueragile/image/upload/v1601450698/web/jinka/Apple.png"
                height={58}
                alt="Télécharger dans l'App Store"
              />
            </Box>
            <Box
              as="a"
              href={google_play_link}
              target="_blank"
              rel="noopener noreferrer"
              textAlign="center"
            >
              <Box
                as="img"
                src="https://res.cloudinary.com/loueragile/image/upload/v1601450698/web/jinka/Google.png"
                height={58}
                alt="Disponible sur Google Play"
              />
            </Box>
          </Box>
        </ModalSimple>
      ) : null}

      <Box
        as="button"
        className="btn is-medium is-n_secondary"
        mt={{ md: 20, xs: 0 }}
        width="100%"
        variant="n_secondary"
        onClick={() => {
          set_modal_open_jinka(true)
        }}
        display={{ md: 'block', xs: 'none' }}
      >
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
          <IconAdContact />
          <Text as="span" color="white" fontSize={18} ml={10}>
            Message
          </Text>
        </Box>
      </Box>
    </>
  )
}

// XXX pas de stats pour user_log + api deprecated
export const ResultContactInfoLegacy = ({
  ad_id,
  ad_new_real_estate,
  owner_type,
  search_type,
  source,
  source_label,
  source_has_contact,
  linkContact
}) => {
  const linkTotal = React.useMemo(
    () => `${process.env.REACT_APP_API_ENDPOINT.replace('/apiv2', '')}${linkContact}`,
    [linkContact]
  )
  const redirect = React.useCallback(() => {
    document.location.href = linkTotal
  }, [linkTotal])
  const { modal_scam_visible, onModalScamClose, onRedirect } = useModalScam({
    redirect,
    owner_type,
    search_type
  })

  const location = useLocation()
  const qps = qps_from_search(location.search)

  const params_ad_id = ad_id || qps.ad
  const params_context_token = qps.token || ''

  const link = React.useMemo(
    () =>
      absolute_url(
        `/asrenter/app_redirect?path=/ad?id=${params_ad_id}&context_alert_token=${params_context_token}`
      ),
    [params_ad_id, params_context_token]
  )

  return (
    <>
      {modal_scam_visible && <ModalScam onClickModalClose={onModalScamClose} />}
      {source_has_contact ? (
        <QRCodeMessageButtonDesktop link={window && window.location && window.location.href} />
      ) : (
        <Box
          as="button"
          className="btn is-medium is-n_secondary"
          mt={{ md: 20, xs: 0 }}
          width="100%"
          variant="n_secondary"
          onClick={onRedirect}
          display={{ md: 'block', xs: 'none' }}
        >
          {ad_new_real_estate ? 'Recevoir la brochure' : `Voir sur ${source_label || source}`}
        </Box>
      )}
      <OpenInAppButtonMobile link={link} />
    </>
  )
}

const OpenInAppButtonMobile = ({ link }) => {
  return (
    <Box
      as="a"
      className="btn is-medium is-n_secondary"
      mt={{ md: 20, xs: 0 }}
      width="100%"
      variant="n_secondary"
      href={link}
      rel="noopener noreferrer"
      display={{ md: 'none', xs: 'block' }}
    >
      Ouvrir dans l'application Jinka
    </Box>
  )
}

const ResultContactInfo = ({
  ad_id,
  ad_new_real_estate,
  source,
  source_label,
  owner_type,
  search_type
}) => {
  const { load_contact_info, contact_info, redirect, log_stat } = useLA_ad_callbacks(ad_id)
  const [modal_contact_visible, set_modal_contact_visible] = React.useState(false)

  const [phone_visible, set_phone_visible] = React.useState(false)

  const { modal_scam_visible, onModalScamClose, onRedirect } = useModalScam({
    redirect,
    owner_type,
    search_type
  })
  const location = useLocation()
  const qps = qps_from_search(location.search)
  const params_context_token = qps.token || ''
  const link = React.useMemo(
    () =>
      absolute_url(
        `/asrenter/app_redirect?path=/ad?id=${ad_id}&context_alert_token=${params_context_token}`
      ),
    [ad_id, params_context_token]
  )

  React.useEffect(() => {
    load_contact_info()
  }, [load_contact_info])

  if (!contact_info) return null

  if (contact_info.mode === 'redirect') {
    return (
      <>
        {modal_scam_visible && <ModalScam onClickModalClose={onModalScamClose} />}
        <Box
          as="button"
          className="btn is-medium is-n_secondary"
          mt={{ md: 20, xs: 0 }}
          width="100%"
          variant="n_secondary"
          onClick={onRedirect}
        >
          {ad_new_real_estate ? 'Recevoir la brochure' : `Voir sur ${source_label}`}
        </Box>
      </>
    )
  }

  if (contact_info.message_form === 'form_rent') {
    return (
      <>
        <QRCodeMessageButtonDesktop link={window && window.location && window.location.href} />
        <OpenInAppButtonMobile link={link} />
      </>
    )
  }

  return (
    <>
      {modal_contact_visible && (
        <ModalContact
          ad_id={ad_id}
          onClose={() => set_modal_contact_visible(false)}
          message_form={contact_info.message_form}
        />
      )}
      <Box flexDirection="row" display="flex" mt={{ md: 20, xs: 0 }}>
        {contact_info.message_form && (
          <Box flex={1} mr={contact_info.phone ? 10 : 0}>
            <Box
              as="button"
              width={1}
              className="btn is-medium is-n_secondary"
              onClick={() => {
                log_stat('CONTACT_BUTTON')
                set_modal_contact_visible(true)
              }}
            >
              <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                <IconAdContact />
                <Text as="span" color="white" fontSize={18} ml={10}>
                  Message
                </Text>
              </Box>
            </Box>
          </Box>
        )}

        {contact_info.phone && (
          <Box flex={1} ml={contact_info.message_form ? 10 : 0}>
            <Box
              as="button"
              width={1}
              style={{ paddingLeft: 0, paddingRight: 0 }}
              className="btn is-medium is-n_secondary"
              onClick={() => {
                log_stat('CONTACT_BUTTON')
                log_stat('PHONE')
                set_phone_visible(true)
              }}
            >
              <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                <IconAdTel />
                {!phone_visible ? (
                  <Text as="span" color="white" fontSize={18} ml={10}>
                    Appeler
                  </Text>
                ) : (
                  <Text
                    as="a"
                    color="white"
                    fontSize={15}
                    ml={10}
                    href={`tel:${contact_info.phone}`}
                  >
                    {contact_info.phone}
                  </Text>
                )}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  )
}

export default ResultContactInfo
